/* GLASSFITS theme scripts — no dependencies, no libraries. */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     Mobile navigation drawer
     --------------------------------------------------------------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) setOpen(false);
    });
  }

  /* ---------------------------------------------------------------
     Header shadow once the page has scrolled
     --------------------------------------------------------------- */
  function initHeaderState() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var ticking = false;

    function update() {
      header.classList.toggle('header--scrolled', window.scrollY > 12);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ---------------------------------------------------------------
     Reveal on scroll
     --------------------------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------
     Sticky mobile contact bar — appears after the hero
     --------------------------------------------------------------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    if (!bar) return;
    document.body.classList.add('has-sticky-bar');

    var ticking = false;
    function update() {
      bar.classList.toggle('is-visible', window.scrollY > 280);
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ---------------------------------------------------------------
     Quote form helpers: uppercase reg + postcode, scroll to result
     --------------------------------------------------------------- */
  function initForms() {
    document.querySelectorAll('[data-uppercase]').forEach(function (input) {
      input.addEventListener('input', function () {
        var start = input.selectionStart;
        input.value = input.value.toUpperCase();
        if (start !== null) input.setSelectionRange(start, start);
      });
    });

    var result = document.querySelector('[data-form-status]');
    if (result) {
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  }

  /* ---------------------------------------------------------------
     Count-up for stat figures
     --------------------------------------------------------------- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length || reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count-to'));
        if (isNaN(target)) { observer.unobserve(el); return; }
        var duration = 1100;
        var startTime = null;

        function tick(now) {
          if (!startTime) startTime = now;
          var progress = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased).toString();
          if (progress < 1) window.requestAnimationFrame(tick);
        }

        window.requestAnimationFrame(tick);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------
     Glass diagram: highlight the panel matching the dropdown choice
     --------------------------------------------------------------- */
  function initGlassDiagram() {
    var select = document.querySelector('[data-glass-select]');
    var diagram = document.querySelector('[data-glass-diagram]');
    if (!select || !diagram) return;

    var zones = diagram.querySelectorAll('.glass-zone');

    function paint() {
      var value = select.value;
      zones.forEach(function (zone) {
        zone.classList.toggle('is-selected', value !== '' && zone.getAttribute('data-glass') === value);
      });
    }

    // Clicking a panel selects it in the dropdown too
    zones.forEach(function (zone) {
      zone.style.cursor = 'pointer';
      zone.addEventListener('click', function () {
        var name = zone.getAttribute('data-glass');
        var match = Array.prototype.filter.call(select.options, function (option) {
          return option.value === name;
        })[0];
        if (match) {
          select.value = name;
          paint();
        }
      });
    });

    select.addEventListener('change', paint);
    paint();
  }

  /* ---------------------------------------------------------------
     Registration lookup (DVLA, via a Netlify function)
     Fills in what we can. The customer can always overtype it, and
     the form works normally if the lookup is off or unavailable.
     --------------------------------------------------------------- */
  function initRegLookup() {
    var input = document.querySelector('[data-reg-lookup]');
    if (!input) return;
    // No endpoint set in theme settings: stay silent, the form works as normal.
    if (!input.getAttribute('data-reg-endpoint')) return;

    var status = document.querySelector('[data-reg-status]');
    var makeField = document.getElementById('QuoteMake');
    var yearField = document.querySelector('[data-reg-year]');
    var colourField = document.querySelector('[data-reg-colour]');
    var fuelField = document.querySelector('[data-reg-fuel]');
    var endpoint = input.getAttribute('data-reg-endpoint') || '';
    var lastLookup = '';
    var debugMode = window.location.search.indexOf('debug=1') !== -1;

    var MSG_NOT_FOUND = 'We couldn\u2019t find that registration \u2014 please type your vehicle details in.';
    var MSG_UNAVAILABLE = 'Lookup unavailable right now \u2014 please type your vehicle details in.';

    function setStatus(state, message) {
      if (!status) return;
      status.className = 'reg-status' + (state ? ' reg-status--' + state : '');
      status.innerHTML = state === 'loading'
        ? '<span class="reg-spinner" aria-hidden="true"></span>' + message
        : message;
    }

    function titleCase(text) {
      return String(text).toLowerCase().replace(/\b[a-z]/g, function (c) {
        return c.toUpperCase();
      });
    }

    function lookup() {
      var reg = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');

      if (reg.length < 2) {
        setStatus('', '');
        lastLookup = '';
        return;
      }
      if (reg === lastLookup) return;
      lastLookup = reg;

      setStatus('loading', 'Looking up your vehicle\u2026');

      fetch(endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'reg=' + encodeURIComponent(reg))
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
        })
        .then(function (result) {
          if (result.status === 503) {
            // Lookup not switched on yet. Customers see nothing; the owner
            // gets a console note, or an on-screen note with ?debug=1
            if (window.console && console.warn) {
              console.warn('Glassfits: registration lookup is not configured. ' +
                'Check the lookup endpoint URL in Theme settings.');
            }
            if (debugMode) {
              setStatus('warn', 'Debug: lookup endpoint returned 503 (no API key set on the endpoint).');
            } else {
              setStatus('', '');
            }
            return;
          }
          if (result.status === 404 || result.status === 400) {
            setStatus('warn', MSG_NOT_FOUND);
            return;
          }
          if (!result.ok) {
            if (window.console && console.warn) {
              console.warn('Glassfits: reg lookup failed', result.status, result.data);
            }
            setStatus('warn', debugMode
              ? 'Debug: lookup failed with status ' + result.status + ' \u2014 ' +
                JSON.stringify(result.data)
              : MSG_UNAVAILABLE);
            return;
          }

          var v = result.data || {};
          if (yearField) yearField.value = v.year || '';
          if (colourField) colourField.value = v.colour || '';
          if (fuelField) fuelField.value = v.fuel || '';

          if (v.make && makeField && !makeField.value.trim()) {
            makeField.value = titleCase(v.make);
            makeField.classList.add('is-autofilled');
            window.setTimeout(function () {
              makeField.classList.remove('is-autofilled');
            }, 1800);
          }

          var parts = [];
          if (v.make) parts.push(titleCase(v.make));
          if (v.year) parts.push(v.year);
          if (v.colour) parts.push(titleCase(v.colour));

          if (parts.length) {
            setStatus('ok', 'Found: <strong>' + parts.join(' \u00b7 ') +
              '</strong>. Please add the model above.');
          } else {
            setStatus('warn', MSG_NOT_FOUND);
          }
        })
        .catch(function () {
          setStatus('warn', MSG_UNAVAILABLE);
        });
    }

    input.addEventListener('blur', lookup);
    input.addEventListener('change', lookup);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        lookup();
      }
    });
  }

  function init() {
    initNav();
    initHeaderState();
    initReveal();
    initStickyBar();
    initForms();
    initCounters();
    initGlassDiagram();
    initRegLookup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when sections are re-rendered inside the Shopify theme editor
  document.addEventListener('shopify:section:load', init);
})();
